import { render, staticRenderFns } from "./MessagesArea.vue?vue&type=template&id=4a322c1e&scoped=true"
import script from "./MessagesArea.vue?vue&type=script&lang=js"
export * from "./MessagesArea.vue?vue&type=script&lang=js"
import style0 from "./MessagesArea.vue?vue&type=style&index=0&id=4a322c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a322c1e",
  null
  
)

export default component.exports